<p>view works!</p>
<div class="content-center">
	<nav class="navbar navbar-expand-lg" id="breadcrumbs">
		<div class="container-fluid">
			<!-- Display the Location of the Assets being viewed -->
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb ">
					<li class="breadcrumb-item" *ngFor="let parent of locationParents" (click)="locationSelect(parent)"
						[matTooltip]="parent.Description">
						<span style="display: flex;"><mat-icon style="color: grey !important"/>{{parent.Name}}</span>
					</li>
				</ol>
			</nav>

			<!-- Add an expanding SPAN between left and right elements -->
			<span class="navbar-nav me-auto mb-2 mb-lg-0"></span>

			<!-- Home Icon -->
			<!-- <mat-icon style="margin-right: 1em;" matTooltip="Home Selected">home</mat-icon> -->

			<!-- Collapse and expand icons -->
			<mat-icon *ngIf="isCollapsed" (click)="isCollapsed = ! isCollapsed">expand_more</mat-icon>
			<mat-icon *ngIf="!isCollapsed" (click)="isCollapsed = ! isCollapsed">expand_less</mat-icon>
		</div>
	</nav>

	<!-- Display Colapseble Area -->
	<div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" id="ngbCollapse">
		<div class=" parent">
			<div id='treeparent' class="childTree">
				{{selectedLocation}}
				<!-- <ejs-dropdowntree id='dropdowntree' [fields]='fields' [text]="selectedLocation" placeholder='Select a Item'
					(select)="dropdowntreeSelect($event)" [showClearButton]="false"></ejs-dropdowntree>				 -->
				<div class="imgCont mat-elevation-z4">
					<img src="{{imagePathSubLocations()}}{{child.Id}}?{{child.Modified}}" *ngIf="hierarchicalLocation"
						title="{{hierarchicalLocation.Name}} - {{hierarchicalLocation.LocationType}}"
						onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
						[attr.x-contenttype]="'image/png'" />
				</div>
			</div>

			<div class="HierarchyContent" id="HierarchyContent" style="padding:1em">
				<span class="top-right" matTooltip="Add Location or Asset">
					<mat-icon [matMenuTriggerFor]="newEntry">add_box</mat-icon>
				</span>
				<ng-container *ngIf="locationAssets.length > 0; then ngAssetTemplate;"
					style="margin-right: 20px;"></ng-container>
				<ng-container *ngIf="locationChildren.length > 0; then ngSubLocationTemplate;"
					style="margin-right: 20px;"></ng-container>
			</div>
		</div>
	</div>

	<!-- Area to Display the Asset Selection Details -->
	<router-outlet *ngIf="locationChildren || locationAssets"></router-outlet>

</div>

<mat-menu #newEntry="matMenu" [overlapTrigger]="false" yPosition="below">
	<button class="app-icon app-icon--add-asset" mat-menu-item (click)="addAsset(hierarchicalLocation!)">
		<mat-icon/><span>New Asset</span>
	</button>
	<button class="app-icon app-icon--add-location" mat-menu-item (click)="addLocation(hierarchicalLocation!)">
		<mat-icon/><span>New Location</span>
	</button>
</mat-menu>

<ng-template #ngLocationImage>
	<span *ngIf="hierarchicalLocation!.Level > 1">Location Image</span>
	<div class="flex-wrap mat-elevation-z4" *ngIf="hierarchicalLocation!.Level > 1" style="border:none">
		<img src="{{imagePathSubLocations()}}{{child.Id}}?{{child.Modified}}" *ngIf="hierarchicalLocation" style="max-height: 600px;"
			title="{{hierarchicalLocation.Name}} - {{hierarchicalLocation.LocationType}}"
			onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
			[attr.x-contenttype]="'image/png'" />
	</div>
</ng-template>

<!-- [ngStyle]="hierarchicalLocation.Level > 1 ? {'background-image': 'url(' + hierarchicalLocation.ImageURL + ')'} : {}" -->
<!-- Template for Children -->
<ng-template #ngSubLocationTemplate>
	Function Locations
	<span class="flex-wrap" id="ngSubLocationTemplate">
		<div id="ngLocationDiv" class="" fxFlex="0 0 calc(var(--view-card-width) + 1em)"
			*ngFor="let subLocation of locationChildren" matTooltip="{{subLocation.Name}}">
			<app-hierarchy-sub-location (selected)="locationSelect($event)" [AdminSite]="thisUser.AdminSite" [child]=subLocation [accountID]="accountID"
				[OrganisationID]="OrganisationID"></app-hierarchy-sub-location>
		</div>
	</span>
</ng-template>

<ng-template #ngAssetTemplate>
	<!-- <ng-container *ngTemplateOutlet="ngLocationImage" style="margin-right: 20px;"></ng-container> -->
	Assets
	<div class="flex-wrap" id="ngAssetTemplate">
		<div id="ngAssetDiv" class="" fxFlex="0 0 calc(var(--view-card-width) + 1em)"
			*ngFor="let asset of locationAssets" matTooltip="{{asset.Name}}" matTooltip="{{asset.Name}}">
			<app-hierarchy-asset (selected)="assetSelect($event)" [asset]=asset [accountID]="accountID"
				[OrganisationID]="OrganisationID"></app-hierarchy-asset>
		</div>

	</div>
</ng-template>
